<template>
  <div class="header">
    <div class="top">
      <div class="main">
        <a href="/" class="logo">
          <span class="logo_pic"></span>
          <span class="logo_z1">
            <h2>天津市华夏器官移植救助基金会</h2>
            <p>Tianjinshi Huaxia Organ Transplantation Aid Foundation</p>
          </span>
          <span class="logo_z2">
            <h3>救助申请审批系统</h3>
            <p>Rescue application approval system</p>
          </span>
        </a>
        <span class="top_tel_pc pc">{{ GLOBAL.sys_tel }}</span>
        <a :href="'tel://' + GLOBAL.sys_tel" class="cd_top_tel mob"></a>
        <a
          href="javascript:void(0)"
          class="menu_mob mob"
          :class="{ active: navk }"
          @click="nav_mob()"
        ></a>
        <div class="top_user">
          <a
            href="javascript:void(0)"
            class="top_user_rk"
            :class="{ active: top_userk }"
            @click="top_user_mob()"
          ></a>
          <div class="txtk" v-if="!$myStore.state.token" :class="{ active: top_userk }">
            <a href="javascript:void(0)" @click="open_page('/login')" class="cd_u">未登录</a>
          </div>
          <div class="txtk" v-else :class="{ active: top_userk }">
            <a href="javascript:void(0)" @click="open_page('/user/userhome')" class="cd_u">{{$myStore.state.RealName}}</a> | <a href="javascript:void(0)" @click="$store.commit('LOGOUT')">退出</a>
          </div>
        </div>
      </div>
    </div>
    <div class="navk" :class="{ active: navk }">
      <div class="main">
        <ul class="nav">
          <li
            v-for="item in configNav"
            @click="selected(item.path)"
            :class="class_path.indexOf(item.path) >= 0 ? 'active' : ''"
          >
            <router-link :to="item.path">{{ item.name }}</router-link>
          </li>
        </ul>
      </div>
    </div>
    <div class="top_jg"></div>
  </div>
</template>

<script>
export default {
  name: "app-header",
  data() {
    return {
      // toptel: "022-87636202",
      navk: false, //手机导航默认隐藏
      top_userk: false, //手机端会员入口
      class_path: this.$route.path,
      configNav: [
        {
          name: "首页",
          path: "/user/userhome",
        },

        {
          name: "我的申请",
          path: "/user/usersplist",
        },
        {
          name: "项目公示",
          path: "/pro_list",
        },
        {
          name: "帮助中心",
          path: "/help_list",
        },
      ],
    };
  },
  methods: {
    selected: function (path) {
      this.class_path = path;
      this.navk = !this.navk;
    },
    nav_mob() {
      if (this.navk == false) {
        this.navk = !this.navk;
      } else {
        this.navk = !this.navk;
      }
    },
    top_user_mob() {
      if (this.top_userk == false) {
        this.top_userk = !this.top_userk;
      } else {
        this.top_userk = !this.top_userk;
      }
    },
  },
  created() {},
};
</script>



// WEBPACK FOOTER //
// src/components/include/top.vue